export enum BetSectionPickerType {
    QuickBet = "RYCHLÁ SÁZKA",
    FillTicket = "VYPLNIT SÁZENKU",
}
